module.exports = __webpack_public_path__ + "img/9-text.d02fb14a.png";